/*!
 * @license
 * Copyright (C) 2020 Michael L Haufe
 * SPDX-License-Identifier: AGPL-3.0-only
 * @see <https://spdx.org/licenses/AGPL-3.0-only.html>
 */

import curry from './curry';
import fix from './fix';
import lazy from './lazy';
import memo from './memo';
import {partial, _} from './partial';

export {curry, fix, lazy, memo, partial, _};